module.exports = __webpack_public_path__ + "img/SL.732a63b1.png";